<div
    style="display: flex; gap: 10px; flex-direction: column;left: 5%;width: 90%; position: relative; margin-top: 15px;">
    <div
        style="color: #0E0E0E; font-size: 16px; font-family: Montserrat; font-weight: 600; letter-spacing: 0.04px; word-wrap: break-word">
        <img style="cursor: pointer;" src="assets/back-icon.svg" routerLink="/admin/banner-hub/banner-list">
        Schedule new banner
    </div>
    <div class="main-box" fxLayout="row" style="min-height: 30rem;">
        <div fxFlex="50" class="upload-div">
            <div *ngIf="bannerImageIdAfterUpload==''">
                <button type="button" class="verify-btn verify-btn-class" fxLayoutAlign="center center"
                    (click)="triggerInputImage.click()">Upload an Image</button>
                <div style="width: 100%; text-align: center"><span
                        style="color: #999999; font-size: 10px; font-family: Montserrat; font-weight: 500; line-height: 15px; letter-spacing: 0.20px; word-wrap: break-word">Select
                        banner image as JPG or PNG </span><span
                        style="color: #999999; font-size: 10px; font-family: Montserrat; font-weight: 500; text-transform: lowercase; line-height: 15px; letter-spacing: 0.20px; word-wrap: break-word">SMALLER
                        THAN</span><span
                        style="color: #999999; font-size: 10px; font-family: Montserrat; font-weight: 500; line-height: 15px; letter-spacing: 0.20px; word-wrap: break-word">
                        10 MB</span></div>
                <input #triggerInputImage type="file" accept=".jpg, .png" (change)="handleInputImage($event)"
                    style="display: none;" />
            </div>
            <div *ngIf="bannerImageIdAfterUpload!=''"
                style="display: flex;flex-direction: column;align-items: center;gap: 10px;">
                <img style="border-radius: 14.79px;height: 210px; width: 90%;" [src]="imageSrc">
                <div (click)="triggerChangeImage.click()"
                    style="color: #386AF6; font-size: 12px; font-family: Montserrat; font-weight: 500; word-wrap: break-word; cursor: pointer;">
                    Change Banner</div>
                <input #triggerChangeImage type="file" accept=".jpg, .png" (change)="handleInputImage($event)"
                    style="display: none;" />
            </div>

        </div>
        <hr style="height: 500px;width: 2px;">
        <div fxFlex="50" fxLayout="column" style="gap: 10px;">
            <div class="radio-div">
                <div class="form-text-label title-form" style="margin-bottom: 15px;">Select category</div>
                <mat-radio-group aria-label="Select an option" [(ngModel)]="selectedBannerType">
                    <mat-radio-button [value]="type.value" [checked]="type.checked" style="margin-right: 10px;"
                        *ngFor="let type of bannerType">
                        <span class="radio-text">{{type.name}}</span>
                    </mat-radio-button>
                </mat-radio-group>
            </div>
            <div *ngIf="selectedBannerType=='BOT'" fxLayout="column" style="gap: 10px;">
                <span class="title-form">Link to</span>
                <button style="border-radius: 8px;border: 1px #ECECEC solid;background: #F4F6FA;width: 100%;">
                    <mat-select [(value)]="selectedBot" class="dropdown-text" style="padding: 10px;">
                        <mat-option *ngFor="let bot of bots" [value]="bot.bot_id"
                            class="dropdown-text">{{bot.configuration.name}}
                        </mat-option>
                    </mat-select>
                </button>
            </div>
            <div *ngIf="selectedBannerType=='URL'" fxLayout="column" style="gap: 10px;">
                <span class="title-form">Add URL</span>
                <input matInput placeholder="Enter URL" [(ngModel)]="urlLink">
            </div>
            <div
                style="width: 100%; padding-top: 9px; padding-bottom: 8px; padding-left: 20.10px; padding-right: 414.90px; background: #F4F6FA; border-radius: 8px; overflow: hidden; justify-content: flex-start; align-items: center; display: inline-flex; margin-top: 20px;">
                <div
                    style="color: #0E0E0E; font-size: 12px; font-family: Montserrat; font-weight: 600; letter-spacing: 0.20px; word-wrap: break-word">
                    Select banner duration</div>
            </div>

            <span class="title-form">From</span>
            <div fxLayout="row" style="gap: 100px;">
                <div fxLayout="row" style="gap: 50px; align-items: center;">
                    <button class="mx-1 col-md-3" class="date-button" id="reportrange" type="button">
                        <span>
                            <img src="assets/calender.svg">
                        </span>
                        <input matInput [min]="minEndDate" [matDatepicker]="picker1" class="text" style="background-color:transparent;border: 0px solid;"
                            placeholder="Select Date" 
                            [formControl]="startDateForm">
                        <mat-datepicker-toggle matSuffix [for]="picker1">
                            <mat-icon matDatepickerToggleIcon style="color: #386AF6">arrow_drop_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                    </button>
                </div>
                <div fxLayout="row" style="gap: 50px; align-items: center;">
                    <button class="mx-1 col-md-3" class="date-button" id="reportrange" type="button" style="width: 100%;">
                        <img src="assets/clock.svg">
                        <input type="time" class="time-style text" [(ngModel)]="startTime">
                        <mat-icon matDatepickerToggleIcon style="color: #386AF6">arrow_drop_down</mat-icon>
                    </button>
                </div>
            </div>






            <span class="title-form">To</span>
            <div fxLayout="row" style="gap: 100px;">
                <div fxLayout="row" style="gap: 50px; align-items: center;">
                    <button class="mx-1 col-md-3" class="date-button" id="reportrange" type="button">
                        <span>
                            <img src="assets/calender.svg">
                        </span>
                        <input matInput [min]="minEndDate" [matDatepicker]="picker2" class="text" style="background-color:transparent;border: 0px solid;"
                            placeholder="Select Date" 
                            [formControl]="endDateForm">
                        <mat-datepicker-toggle matSuffix [for]="picker2">
                            <mat-icon matDatepickerToggleIcon style="color: #386AF6">arrow_drop_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                    </button>
                </div>
                <div fxLayout="row" style="gap: 50px; align-items: center;">
                    <button class="mx-1 col-md-3" class="date-button" id="reportrange" type="button" style="width: 100%;">
                        <img src="assets/clock.svg">
                        <input type="time" class="time-style text" [(ngModel)]="endTime">
                        <mat-icon matDatepickerToggleIcon style="color: #386AF6">arrow_drop_down</mat-icon>
                    </button>
                </div>
            </div>


            <div fxLayout="row" style="align-self: center;">
                <button routerLink="/admin/banner-hub/banner-list" type="button" class="verify-btn verify-btn-class" style="background: white; color: #386AF6;" fxLayoutAlign="center center">Cancel</button>
                <button *ngIf="!checkAllField()"  type="button" class="verify-btn verify-btn-class" style="background: #C3D2FC;" fxLayoutAlign="center center">Schedule</button>
                <button *ngIf="checkAllField()" (click)="scheduleBanner()" type="button" class="verify-btn verify-btn-class" fxLayoutAlign="center center">Schedule</button>
            </div>



        </div>
    </div>
</div>